"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmbedPDF = EmbedPDF;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
const Container = (0, _styledComponents.default)(_renderer.PDFViewer)`
  border: 0;
  box-sizing: border-box;

  ${({
  height
}) => height && (0, _styledComponents.css)`
      height: calc(${height});

      /* Prevent the body from having a scroll-bar */
      ${height === '100%' && (0, _styledComponents.css)`
        margin-bottom: -4px;
      `}
    `}

  ${({
  width
}) => width && (0, _styledComponents.css)`
      width: ${width};
    `}
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
/**
 * A component for embedding PDFs that have been created with the `@a1s/pdf` library.
 */
function EmbedPDF({
  children,
  height,
  width
}) {
  return /*#__PURE__*/_react.default.createElement(Container, {
    height: height,
    width: width
  }, children);
}